import { QUIZ_IDS } from 'src/funnels/common/config/funnels';

export const enum COURSES_IDS {
  OWN_YOUR_THRONE = 'recTgAX5RFS9l6TVg',
  LOVE_DOMINATRIX = 'recLVL9JImGGYvEkj',
  POST_BREAKUP = 'recznGwRlrZuSRecW',
  FEMME_POWER = 'recqPpDqXgtjJMDEz',
}

export const DEFAULT_COURSE_ID = COURSES_IDS.LOVE_DOMINATRIX;

export const CREO_TOPICS = {
  breakup: COURSES_IDS.POST_BREAKUP,
};

export const RECOMMENDED_COURSES_BY_QUIZ_IDS: Record<QUIZ_IDS, COURSES_IDS> = {
  [QUIZ_IDS.MT]: COURSES_IDS.LOVE_DOMINATRIX,
  [QUIZ_IDS.MT_NT]: COURSES_IDS.LOVE_DOMINATRIX,
  [QUIZ_IDS.MT_HP]: COURSES_IDS.LOVE_DOMINATRIX,
  [QUIZ_IDS.MT_CS]: COURSES_IDS.LOVE_DOMINATRIX,
  [QUIZ_IDS.THREE_IN_ONE_NT]: COURSES_IDS.FEMME_POWER,
  [QUIZ_IDS.BR_NT]: COURSES_IDS.POST_BREAKUP,
  [QUIZ_IDS.FF_1M]: COURSES_IDS.FEMME_POWER,
} as const;
